(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cb-careers-build-next"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('cb-careers-hero-slider')) {
    class CrossbeatsHeroSlider extends HTMLElement {
      connectedCallback() {
        this.frame = requestAnimationFrame(() => this.initialize());
      }

      initialize() {
        if (!this.isConnected || this.initialized) return;

        this.track = this.querySelector('.cbh-gallery-track');
        this.controls = this.querySelector('.cbh-gallery-controls');
        this.toggle = this.querySelector('[data-autoplay-toggle]');
        this.dots = Array.from(this.querySelectorAll('[data-slide]'));
        this.slides = Array.from(this.querySelectorAll('.cbh-photo'));

        if (
          !this.track ||
          !this.controls ||
          !this.toggle ||
          this.slides.length < 2
        ) return;

        this.initialized = true;

        this.mobile = window.matchMedia('(max-width: 760px)');
        this.reducedMotion = window.matchMedia(
          '(prefers-reduced-motion: reduce)'
        );

        const configuredInterval = Number(this.dataset.interval);

        this.delay = Number.isFinite(configuredInterval)
          ? Math.max(2000, configuredInterval)
          : 4000;

        this.index = 0;
        this.paused =
          this.dataset.autoplay !== 'true' ||
          this.reducedMotion.matches;

        this.hovered = false;
        this.focused = false;
        this.dragging = false;
        this.inView = false;

        this.events = new AbortController();
        const signal = this.events.signal;

        this.dots.forEach(dot => {
          dot.addEventListener('click', event => {
            /*
             * Pointer/touch navigation can resume the timer.
             * Keyboard navigation keeps the carousel paused on focus.
             */
            if (event.detail > 0) this.focused = false;

            this.goTo(Number(dot.dataset.slide));
          }, { signal });
        });

        this.toggle.addEventListener('click', () => {
          this.paused = !this.paused;

          /*
           * Explicitly pressing Play starts playback even while
           * the Play button still has focus.
           */
          if (!this.paused) {
            this.focused = false;
            this.hovered = false;
          }

          this.updateToggle();
          this.schedule();
        }, { signal });

        this.track.addEventListener('scroll', () => {
          if (!this.mobile.matches) return;

          const width = this.track.clientWidth;
          if (!width) return;

          this.index = Math.max(
            0,
            Math.min(
              this.slides.length - 1,
              Math.round(this.track.scrollLeft / width)
            )
          );

          this.updateDots();
          this.schedule();
        }, { passive: true, signal });

        this.track.addEventListener('keydown', event => {
          if (
            event.target !== this.track ||
            !this.mobile.matches
          ) return;

          if (event.key === 'ArrowRight') {
            event.preventDefault();
            this.goTo(this.index + 1);
          }

          if (event.key === 'ArrowLeft') {
            event.preventDefault();
            this.goTo(this.index - 1);
          }
        }, { signal });

        this.track.addEventListener('pointerdown', () => {
          if (!this.mobile.matches) return;

          this.dragging = true;
          clearTimeout(this.timer);
        }, { signal });

        const finishDrag = () => {
          if (!this.dragging) return;

          this.dragging = false;
          this.schedule();
        };

        window.addEventListener('pointerup', finishDrag, { signal });
        window.addEventListener('pointercancel', finishDrag, { signal });

        this.addEventListener('pointerenter', event => {
          if (
            event.pointerType !== 'mouse' ||
            !this.mobile.matches
          ) return;

          this.hovered = true;
          clearTimeout(this.timer);
        }, { signal });

        this.addEventListener('pointerleave', event => {
          if (event.pointerType !== 'mouse') return;

          this.hovered = false;
          this.schedule();
        }, { signal });

        this.addEventListener('focusin', () => {
          if (!this.mobile.matches) return;

          this.focused = true;
          clearTimeout(this.timer);
        }, { signal });

        this.addEventListener('focusout', event => {
          this.focused = this.contains(event.relatedTarget);
          this.schedule();
        }, { signal });

        document.addEventListener('visibilitychange', () => {
          this.schedule();
        }, { signal });

        this.mobile.addEventListener('change', () => {
          this.refreshLayout();
        }, { signal });

        this.reducedMotion.addEventListener('change', () => {
          if (this.reducedMotion.matches) {
            this.paused = true;
          }

          this.updateToggle();
          this.schedule();
        }, { signal });

        /*
         * Re-align the slide when its actual container width changes,
         * including resizing the Shopify editor preview.
         */
        this.resizeObserver = new ResizeObserver(() => {
          const width = this.track.clientWidth;

          if (width === this.lastWidth) return;

          this.lastWidth = width;
          this.alignSlide();
          this.schedule();
        });

        this.resizeObserver.observe(this.track);

        /*
         * Stop the timer when the gallery is outside the viewport.
         */
        this.visibilityObserver = new IntersectionObserver(entries => {
          this.inView = entries[0].isIntersecting;
          this.schedule();
        });

        this.visibilityObserver.observe(this);

        this.updateToggle();
        this.updateDots();
        this.refreshLayout();
      }

      refreshLayout() {
        clearTimeout(this.timer);

        const isMobile = this.mobile.matches;

        this.controls.hidden = !isMobile;

        if (isMobile) {
          this.track.setAttribute('tabindex', '0');
          this.track.setAttribute('aria-roledescription', 'carousel');

          this.slides.forEach((slide, index) => {
            slide.setAttribute('role', 'group');
            slide.setAttribute('aria-roledescription', 'slide');
            slide.setAttribute(
              'aria-label',
              `${index + 1} of ${this.slides.length}`
            );
          });
        } else {
          /*
           * Desktop is a static grid:
           * no timer, no carousel controls, no carousel keyboard focus.
           */
          this.index = 0;
          this.dragging = false;
          this.hovered = false;
          this.focused = false;

          this.track.removeAttribute('tabindex');
          this.track.removeAttribute('aria-roledescription');

          this.slides.forEach(slide => {
            slide.removeAttribute('role');
            slide.removeAttribute('aria-roledescription');
            slide.removeAttribute('aria-label');
          });
        }

        this.alignSlide();
        this.updateDots();
        this.schedule();
      }

      alignSlide() {
        this.track.scrollTo({
          left: this.mobile.matches
            ? this.index * this.track.clientWidth
            : 0,
          behavior: 'auto'
        });
      }

      updateToggle() {
        this.toggle.textContent = this.paused ? 'Play' : 'Pause';

        this.toggle.setAttribute(
          'aria-label',
          this.paused ? 'Play slideshow' : 'Pause slideshow'
        );
      }

      updateDots() {
        this.dots.forEach((dot, index) => {
          dot.setAttribute(
            'aria-pressed',
            String(index === this.index)
          );
        });
      }

      goTo(index) {
        /*
         * This guard prevents sliding on desktop.
         */
        if (!this.mobile.matches) return;

        clearTimeout(this.timer);

        this.index = (
          index + this.slides.length
        ) % this.slides.length;

        this.track.scrollTo({
          left: this.index * this.track.clientWidth,
          behavior: this.reducedMotion.matches ? 'auto' : 'smooth'
        });

        this.updateDots();
        this.schedule();
      }

      schedule() {
        clearTimeout(this.timer);

        /*
         * Autoplay runs only on mobile while the gallery is visible.
         */
        if (
          !this.isConnected ||
          !this.mobile.matches ||
          this.paused ||
          this.hovered ||
          this.focused ||
          this.dragging ||
          !this.inView ||
          document.hidden
        ) return;

        this.timer = setTimeout(() => {
          this.goTo(this.index + 1);
        }, this.delay);
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        clearTimeout(this.timer);

        this.events?.abort();
        this.resizeObserver?.disconnect();
        this.visibilityObserver?.disconnect();

        this.initialized = false;
      }
    }

    customElements.define(
      'cb-careers-hero-slider',
      CrossbeatsHeroSlider
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cb-careers-impact"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('cb-careers-roles')) {
    class CrossbeatsCareersRoles extends HTMLElement {
      connectedCallback() {
        this.frame = requestAnimationFrame(() => this.initialize());
      }

      initialize() {
        if (!this.isConnected || this.initialized) return;

        this.count = this.querySelector('[data-count]');
        this.noResults = this.querySelector('[data-no-results]');
        this.emptyAll = this.querySelector('[data-empty-all]');

        if (!this.count || !this.noResults || !this.emptyAll) return;

        this.input = this.querySelector('[data-search]');
        this.buttons = Array.from(this.querySelectorAll('[data-team]'));

        this.jobs = Array.from(this.querySelectorAll('[data-job]')).map(element => ({
          element,
          team: element.dataset.teamKey,
          text: this.normalize(
            (element.dataset.searchText || '') + ' ' + element.textContent
          )
        }));

        this.selectedTeam = 'all';

        this.onInput = event => {
          if (event.target === this.input) this.filter();
        };

        this.onClick = event => {
          if (!(event.target instanceof Element)) return;

          const teamButton = event.target.closest('[data-team]');

          if (teamButton && this.contains(teamButton)) {
            this.selectedTeam = teamButton.dataset.team;
            this.filter();
          }

          const reset = event.target.closest('[data-reset]');

          if (reset && this.contains(reset)) {
            this.reset();
          }
        };

        this.onBlockSelect = event => {
          if (String(event.detail?.sectionId) !== this.dataset.sectionId) return;

          const blockId = String(event.detail?.blockId || '');

          const selectedJob = this.jobs.find(
            job => job.element.dataset.blockId === blockId
          );

          if (selectedJob) {
            this.reset();

            if (selectedJob.element.tagName === 'DETAILS') {
              selectedJob.element.open = true;
            }

            selectedJob.element.scrollIntoView({
              block: 'nearest',
              behavior: 'auto'
            });
          } else {
            const selectedButton = this.buttons.find(
              button => button.dataset.blockId === blockId
            );

            if (selectedButton) {
              this.selectedTeam = selectedButton.dataset.team;

              if (this.input) {
                this.input.value = '';
              }

              this.filter();
            }
          }
        };

        this.addEventListener('input', this.onInput);
        this.addEventListener('click', this.onClick);
        document.addEventListener('shopify:block:select', this.onBlockSelect);

        this.querySelectorAll('[data-enhancement]').forEach(control => {
          control.hidden = false;
        });

        const searchControl = this.querySelector('[data-search-control]');

        if (searchControl && this.jobs.length === 0) {
          searchControl.hidden = true;
        }

        this.initialized = true;
        this.dataset.enhanced = 'true';
        this.filter();
      }

      normalize(value) {
        return String(value)
          .normalize('NFD')
          .replace(/[\u0300-\u036f]/g, '')
          .toLowerCase()
          .trim();
      }

      filter() {
        const query = this.normalize(this.input ? this.input.value : '');
        const terms = query.split(/\s+/).filter(Boolean);
        let visible = 0;

        this.jobs.forEach(job => {
          const matches =
            (this.selectedTeam === 'all' || job.team === this.selectedTeam) &&
            terms.every(term => job.text.includes(term));

          job.element.hidden = !matches;

          if (!matches && job.element.tagName === 'DETAILS') {
            job.element.open = false;
          }

          if (matches) {
            visible += 1;
          }
        });

        this.buttons.forEach(button => {
          button.setAttribute(
            'aria-pressed',
            String(button.dataset.team === this.selectedTeam)
          );
        });

        const label = visible === 1
          ? this.dataset.roleSingular
          : this.dataset.rolePlural;

        this.count.textContent = visible + ' ' + label;
        this.noResults.hidden = visible !== 0 || this.jobs.length === 0;
        this.emptyAll.hidden = this.jobs.length !== 0;
      }

      reset() {
        this.selectedTeam = 'all';

        if (this.input) {
          this.input.value = '';
        }

        this.filter();
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.frame);

        if (!this.initialized) return;

        this.removeEventListener('input', this.onInput);
        this.removeEventListener('click', this.onClick);
        document.removeEventListener('shopify:block:select', this.onBlockSelect);

        this.initialized = false;
      }
    }

    customElements.define('cb-careers-roles', CrossbeatsCareersRoles);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cb-story-moments"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('cb-story-moments')) {
    customElements.define('cb-story-moments', class extends HTMLElement {
      connectedCallback() {
        this.frame = requestAnimationFrame(() => this.init());
      }

      init() {
        if (this.initialized) return;

        this.buttons = Array.from(this.querySelectorAll('[data-moment-button]'));
        this.panels = Array.from(this.querySelectorAll('[data-moment-panel]'));
        this.controls = this.querySelector('.cb-moment-controls');
        this.status = this.querySelector('.cb-moment-status');

        if (!this.buttons.length || !this.panels.length) return;

        this.initialized = true;
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };

        this.buttons.forEach(button => {
          button.addEventListener('click', () => {
            this.select(button.dataset.momentButton, true);
          }, options);
        });

        document.addEventListener('shopify:block:select', event => {
          if (!this.contains(event.target)) return;

          const panel = event.target.closest('[data-moment-panel]');
          if (panel) this.select(panel.dataset.momentPanel, false);
        }, options);

        this.classList.add('cb-enhanced');
        this.controls.hidden = this.buttons.length < 2;
        this.select(this.buttons[0].dataset.momentButton, false);
      }

      select(id, animate) {
        const selected = this.panels.find(panel => panel.dataset.momentPanel === id);
        if (!selected) return;

        this.buttons.forEach(button => {
          button.setAttribute(
            'aria-pressed',
            String(button.dataset.momentButton === id)
          );
        });

        this.panels.forEach(panel => {
          panel.hidden = panel !== selected;
          panel.classList.remove('cb-is-changing');
        });

        if (animate) {
          void selected.offsetWidth;
          selected.classList.add('cb-is-changing');

          const button = this.buttons.find(item => item.dataset.momentButton === id);
          this.status.textContent = button.textContent.trim() + ' selected.';
        }
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        if (this.abort) this.abort.abort();
        this.initialized = false;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
